import { useQueries } from '@tanstack/react-query';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';

import { getInventoryItemQueryConfig } from './useGetInventoryItem';

/**
 * Hook for fetching multiple inventory items by their IDs
 * Uses useQueries internally to fetch all items in parallel
 */
export const useGetInventoryItems = (ids: Set<string>, enabled = true) => {
	const currentServicesProviderId = useCurrentServicesProviderId();

	return useQueries({
		queries: Array.from(ids).map((id) =>
			getInventoryItemQueryConfig(currentServicesProviderId, id, enabled),
		),
	});
};
